<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" selector :view-config="auth('b_expense_reimbursement_viewmanage')">
                <template #search>
                    <m-search ref="search" :default-data="defaultSearchData">
                        <m-search-item label="单据编号">
                            <c-input name="document_number"></c-input>
                        </m-search-item>
                        <m-search-item label="申请人">
                            <c-input name="applicant_name"></c-input>
                        </m-search-item>
                        <m-search-item label="报销人">
                            <c-input name="reimburser_name"></c-input>
                        </m-search-item>
                        <m-search-item label="报销类型">
                            <c-select name="reimbursement_type" :options="reimbursementTypeDic" clearable></c-select>
                        </m-search-item>
                        <m-search-item label="申请人网点">
                            <c-select name="applicant_outlet_id" async @search="searchOutlet"></c-select>
                        </m-search-item>
                        <m-search-item label="所在公司">
                            <c-select name="company_id" async @search="searchCompany"></c-select>
                        </m-search-item>
                        <m-search-item label="审批通过时间">
                            <c-datetime start-name="approval_start_date" end-name="approval_end_date" type="datetime" range time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
                        </m-search-item>
                        <m-search-item label="状态">
                            <c-select name="status" multiple :options="applyStatusDic" clearable></c-select>
                        </m-search-item>
                    </m-search>
                </template>
                <!--单据编号-->
                <template #document_number="{data}">
                    <c-link v-if="auth('b_expense_reimbursement_query')" @click="globalDialog('expenseReimbursementDetail', {props: {id: data.id}})">{{data.document_number}}</c-link>
                </template>
                <!--审批状态-->
                <template #status="{data}">
                    <c-state dict="applyStatusDic"  :value="data.status"></c-state>
                </template>
                <!--紧急程度-->
                <template #emergency_level="{data}">
                    <c-state dict="urgencyLevelDic" :value="data.emergency_level"></c-state>
                </template>
                <!--报销类型-->
                <template #reimbursement_type="{data}">
                    <c-state dict="reimbursementTypeDic" :value="data.reimbursement_type"></c-state>
                </template>

                <template #order_number="{data}">
                    <c-link v-if="auth('b_aftersale_order_query')" @click="globalDialog('afterSaleOrderDetail', {props: {id: data.order_id}})">{{data.order_number}}</c-link>
                    <span v-else>{{data.order_number}}</span>
                </template>

                <!--报销金额-->
                <template #total_amount="{data}">
                    ￥{{data.total_amount}}
                </template>

                <!--所在公司-->
                <template #company_name="{data}">
                    {{data.company_name || '-'}}
                </template>


                <template #operate="{data}">
                    <c-button color="main" v-if="auth('b_expense_reimbursement_edit')" prepend-icon="tf-add" @click="$refs.reimbursementEdit.open()">创建费用报销</c-button>
                    <c-button v-if="auth('b_expense_reimbursement_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                    <c-button v-if="auth('b_expense_reimbursement_export')" prepend-icon="tf-export" @click="$refs.view.exportDetailListByViewId()">导出明细</c-button>
                </template>
                <template #batchOperate="{data}">
                    <c-button v-if="auth('b_expense_reimbursement_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                    <c-button color="main" prepend-icon="tf-success" @click="batchApprove(data, 1)">批量通过</c-button>
                    <c-button prepend-icon="tf-reject" @click="batchApprove(data, 9)">批量驳回</c-button>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="220"
                        button-limit="3"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_expense_reimbursement_query')" icon="tf-view" @click="globalDialog('expenseReimbursementDetail', {props: {id: data.id}})">查看</c-table-button>
                        <c-table-button v-if="auth('b_expense_reimbursement_edit') && data.is_founder == 1" :disabled="!(data.status == -1)" icon="tf-edit" @click="$refs.reimbursementEdit.open(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_expense_reimbursement_edit') && data.is_founder == 1" :disabled="!(data.status == -1)" icon="tf-delete" @click="removeExpenseReimbursement(data)">删除</c-table-button>
                        <c-table-button v-if="auth('b_expense_reimbursement_print')" icon="tf-print" :disabled="!(data.status == 1 || data.status == 2)" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <expense-reimbursement-edit ref="reimbursementEdit" @resolve="$refs.view.$refs.list.update()"></expense-reimbursement-edit>
            <!--批量驳回弹窗-->
            <c-dialog ref="rejectDialog" title="批量驳回" width="500" height="200" @resolve="batchRejectHandle">
                <c-form ref="rejectForm" vertical unit-width="100%">
                    <c-form-item label="驳回原因">
                        <c-input name="remark" type="textarea" :rows="3" placeholder="请输入驳回原因"></c-input>
                    </c-form-item>
                </c-form>
            </c-dialog>
        </module>
    </page>
</template>

<script>
import ExpenseReimbursementEdit from "@/pages/finance/expense_reimbursement_edit.vue";
import {mapState} from "vuex";

export default {
    components: {
        ExpenseReimbursementEdit,
    },
    computed: {
        ...mapState(['urgencyLevelDic', 'reimbursementTypeDic','applyStatusDic']),
    },
    data() {
        return {
            workType:11,
            defaultSearchData: {
                'status': []
            }
        }
    },
    mounted() {
        // 监听列表刷新事件
        this.$bus.$on('expense_reimbursement_list.update', data => {
            // 刷新列表
            this.$refs.view.$refs.list.refresh();
            // 刷新二级分组数量
            this.$refs.view.updateTabTotal && this.$refs.view.updateTabTotal();
        });
        // 监听从详情页发起的重新发起事件
        this.$bus.$on('expense_reimbursement_list.edit', data => {
            this.$refs.reimbursementEdit.open(data);
        });
    },

    methods: {
        removeExpenseReimbursement(data) {
            this.$confirm({
                message: '确认删除费用报销【' + (data.application_title || data.document_number) + '】？删除后不可恢复',
                buttonName: '确定',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/expense/reimbursement/delete',
                        data: {id: data.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.$refs.view.$refs.list.update();
                        }
                    });
                },
                cancel: () => {},
            });
        },
        /*******搜索网点*****************/
        searchOutlet(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'AFTERSALE_OUTLET',
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },
        /*******搜索公司*****************/
        searchCompany(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'COMPANY',
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },
        batchApprove(data, executeState) {
            if (!data || !data.length) {
                this.$message({message: '请至少选择一条数据'});
                return;
            }
            let invalidList = data.filter(item => item.status != 1);
            if (invalidList.length) {
                let nums = invalidList.map(item => item.document_number || item.id).join('、');
                this.$message({message: '以下单据非审批中状态，无法操作：' + nums, type: 'warning'});
                return;
            }
            let orderIds = data.map(item => item.id);
            if (executeState == 1) {
                this.$confirm({
                    message: '确定要批量通过选中的 ' + data.length + ' 条费用报销单吗？',
                    buttonName: '确定',
                    cancelButton: true,
                    resolve: () => {
                        this.request({
                            url: '/workflow/order/batch/approve',
                            data: {
                                order_type: 3,
                                execute_state: executeState,
                                order_ids: orderIds
                            },
                            loading: true,
                            success: (data, msg) => {
                                let message = msg || '批量审批成功';
                                if (data && data.fail_list && data.fail_list.length) {
                                    let details = data.fail_list.map(item => item.reason).join('；');
                                    message += '\n' + details;
                                }
                                this.$message({message: message, type: data && data.fail_count ? 'warning' : 'success'});
                                this.$refs.view.batchCancelHandle();
                                setTimeout(() => {
                                    this.$refs.view.$refs.list.update();
                                    this.$refs.view.updateTabTotal && this.$refs.view.updateTabTotal();
                                }, 3000);
                            }
                        });
                    },
                    cancel: () => {},
                });
            } else {
                this._batchOrderIds = orderIds;
                this.$refs.rejectForm.clear();
                this.$refs.rejectDialog.open();
            }
        },

        batchRejectHandle(stop) {
            stop();
            this.$refs.rejectForm.validate({
                rule: {
                    remark: '请输入驳回原因'
                },
                success: formData => {
                    this.request({
                        url: '/workflow/order/batch/approve',
                        data: {
                            order_type: 3,
                            execute_state: 9,
                            order_ids: this._batchOrderIds,
                            remark: formData.remark
                        },
                        loading: true,
                        success: (data, msg) => {
                            let message = msg || '批量驳回成功';
                            if (data && data.fail_list && data.fail_list.length) {
                                let details = data.fail_list.map(item => item.reason).join('；');
                                message += '\n' + details;
                            }
                            this.$message({message: message, type: data && data.fail_count ? 'warning' : 'success'});
                            this.$refs.rejectDialog.close();
                            this.$refs.view.batchCancelHandle();
                            setTimeout(() => {
                                this.$refs.view.$refs.list.update();
                                this.$refs.view.updateTabTotal && this.$refs.view.updateTabTotal();
                            }, 3000);
                        }
                    });
                }
            });
        },
    }
}
</script>

<style lang="stylus" scoped>
</style>
